import styles from "./styles.module.scss";

export default function ExtraButtons({ report, advisor }) {
  return (
    <div className={styles.extraButtonsWrapper}>
      <a
        href={report ? report : undefined}
        target="_blank"
        rel="noreferrer"
        aria-label="Go to report"
        className={styles.reportButton}
        style={{
          opacity: report ? 1 : 0.5,
          cursor: report ? "pointer" : "not-allowed",
        }}
      >
        Read the report
      </a>
      <a
        href={advisor ? advisor : undefined}
        target="_blank"
        rel="noreferrer"
        aria-label="Go to advisor"
        className={styles.askAI}
        style={{
          opacity: advisor ? 1 : 0.5,
          cursor: advisor ? "pointer" : "not-allowed",
        }}
      >
        Ask AI about this transcript
      </a>
    </div>
  );
}
